import { W as WuiFormField$1, d as defineCustomElement$1 } from './form-field.js';

const WuiFormField = WuiFormField$1;
const defineCustomElement = defineCustomElement$1;

export { WuiFormField, defineCustomElement };

//# sourceMappingURL=wui-form-field.js.map